import { ComponentType, type IConfig } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_TANSLATE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.CollapsePanel,
  configGroups: [
    {
      title: 'Panel Properties',
      items: [
        {
          name: 'label',
          label: 'Panel Label',
          valueComponent: {
            type: 'Input',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.Variable,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
          ],
        },
        {
          name: 'labelCustomComponentSchema',
          label: 'Custom Label Component (overrides Panel Label above if set)',
          valueComponent: {
            type: 'SubSchemaEditor',
            props: {
              schemaName: 'labelCustomComponentSchema',
              buttonText: 'Edit Label Component',
            },
          },
          configTypes: [],
          tooltips: [],
        },
        {
          name: 'disabled',
          label: 'Disabled',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'defaultActive',
          label: 'Open by default',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.Variable,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
